import React, { useState, useEffect } from 'react';
import { fetchData, UploadData } from '../axios_URL';
import CompanyTable from './CompanyTable';

import DomainAddIcon from '@mui/icons-material/DomainAdd';
const Homepage = ({ username }) => {
    const [companies, setCompanies] = useState([]);
    const [showLogoutPopup, setShowLogoutPopup] = useState(false);
    const [refresh, setRefresh] = useState([false]);
    const [showAddCompanyPopup, setShowAddCompanyPopup] = useState(false);
    const [files, setFiles] = useState([]);
    const [showFilesPopup, setShowFilesPopup] = useState(false);
    const [selectedCompanyId, setSelectedCompanyId] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileDescription, setFileDescription] = useState('');
    const [isTextMode, setIsTextMode] = useState(false);


    const [newCompany, setNewCompany] = useState({
        companyname: '',
        companyemail: '',
        numberofemployee: 0,
        numberofpackage: 0,
        password: '', // Add this

        uuid: '',
        urlimage: '',
        startdate: '',
        enddate: '',
        cost: 0.0,
        status: '',
        active: false,





        street: null,
        postalCode: null,
        city: null,
        country: null,
        additionaladdress: null,
        telephone_number: null,
        region: null

    });

    // Fetch companies on component mount
    useEffect(() => {
        const getCompanies = async () => {
            try {
                const response = await fetchData('GET', '/api/admin/companies');
                setCompanies(response.data);
            } catch (error) {
                console.error('Error fetching companies:', error);
            }
        };
        getCompanies();
    }, [refresh]);

    
    const handleDeleteFile = async (fileId) => {
        try {
            await fetchData('DELETE', `/api/admin/files/delete/${fileId}`);
            setFiles(files.filter(file => file.id !== fileId));
        } catch (error) {
            console.error('Error deleting file:', error);
        }
    };

    const handleDownloadFile = async (fileId, filename) => {
        try {
            const response = await fetchData('GET', `/api/admin/files/download/${fileId}`, {}, 'blob');
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    };
    const handleFileUpload = async () => {
        if (!selectedFile || !selectedCompanyId || !fileDescription) {
            alert("Please select a file, company, and provide a description.");
            return;
        }

        const formData = new FormData();
        formData.append("file", selectedFile);

        try {
            const response = await UploadData(
                `/api/admin/files/upload/${selectedCompanyId}/${encodeURIComponent(fileDescription)}`,
                {
                    method: "POST",
                    body: formData,  // Sends the form data
                }
            );

            alert(response); // Since backend is sending plain text, display it
            fetchFiles(selectedCompanyId); // Refresh file list
            setSelectedFile(null);
            setFileDescription("");
        } catch (error) {
            alert("File upload failed");
        }
    };





    const fetchFiles = async (companyId) => {
        try {
            const response = await fetchData('GET', `/api/admin/companies/files/${companyId}`);
            setFiles(response.data);
            setSelectedCompanyId(companyId);
            setShowFilesPopup(true);
        } catch (error) {
            console.error('Error fetching files:', error);
        }
    };





    const openAddCompanyPopup = () => {
        setShowAddCompanyPopup(true);
    };

    const closeAddCompanyPopup = () => {
        setShowAddCompanyPopup(false);
    };

    const handleAddCompany = async (e) => {
        e.preventDefault();
        try {
            const response = await fetchData('POST', '/api/admin/companies', newCompany);
            setCompanies((prevCompanies) => [...prevCompanies, response.data]);
            setShowAddCompanyPopup(false);
            setRefresh((prev) => !prev);
            // Reset the form
            setNewCompany({
                companyname: '',
                companyemail: '',
                numberofemployee: 0,
                numberofpackage: 0,
                password: '',

                uuid: '',
                urlimage: '',
                startdate: '',
                enddate: '',
                cost: 0,
                active: false
            });
        } catch (error) {
            console.error('Error adding company:', error);
        }
    };

    return (
        <div  >
        
            <div className="content">
                <h1>Unternehmen</h1>
                <button onClick={openAddCompanyPopup}><DomainAddIcon /></button>
                <CompanyTable companies={companies} fetchFiles={fetchFiles} refresh={setRefresh} />
            </div>

            {showAddCompanyPopup && (
                <div className="modal-overlay">


                    <div className="modal-content">
                        <div className="modalscroll">

                            <div className='AddEmployeeHeader'>
                            Neues Unternehmen hinzufügen
                            </div>
                            <form onSubmit={handleAddCompany}>
                                <label>
                                Unternehmensname:
                                    <input
                                        type="text"
                                        value={newCompany.companyname}
                                        onChange={(e) => setNewCompany({ ...newCompany, companyname: e.target.value })}
                                        required
                                    />
                                </label>
                                <label>
                                E-Mail:
                                    <input
                                        type="email"
                                        value={newCompany.companyemail}
                                        onChange={(e) => setNewCompany({ ...newCompany, companyemail: e.target.value })}
                                        required
                                    />
                                </label>

                                <label>
                                Telefonnummer:
                                    <input
                                        type="text"
                                        value={newCompany.telephone_number || ''}
                                        onChange={(e) => setNewCompany({ ...newCompany, telephone_number: e.target.value })}
                                    />
                                </label>
                                <label>
                                Straße:
                                    <input
                                        type="text"
                                        value={newCompany.street || ''}
                                        onChange={(e) => setNewCompany({ ...newCompany, street: e.target.value })}
                                    />
                                </label>

                                <label>
                                Postleitzahl:
                                    <input
                                        type="text"
                                        value={newCompany.postalCode || ''}
                                        onChange={(e) => setNewCompany({ ...newCompany, postalCode: e.target.value })}
                                    />
                                </label>

                                <label>
                                Stadt:
                                    <input
                                        type="text"
                                        value={newCompany.city || ''}
                                        onChange={(e) => setNewCompany({ ...newCompany, city: e.target.value })}
                                    />
                                </label>

                                <label>
                                Land:
                                    <input
                                        type="text"
                                        value={newCompany.country || ''}
                                        onChange={(e) => setNewCompany({ ...newCompany, country: e.target.value })}
                                    />
                                </label>

                                <label>
                                Zusätzliche Adresse:
                                    <input
                                        type="text"
                                        value={newCompany.additionaladdress || ''}
                                        onChange={(e) => setNewCompany({ ...newCompany, additionaladdress: e.target.value })}
                                    />
                                </label>


                                <label>
                                Region:
                                    <input
                                        type="text"
                                        value={newCompany.region || ''}
                                        onChange={(e) => setNewCompany({ ...newCompany, region: e.target.value })}
                                    />
                                </label>

                                <label>
                                Mitarbeiter:
                                    <input
                                        type="number"
                                        value={newCompany.numberofemployee}
                                        onChange={(e) => setNewCompany({ ...newCompany, numberofemployee: e.target.value })}
                                        required
                                    />
                                </label>
                                <label>
                                Pakete:
                                    <select
                                        value={newCompany.numberofpackage}
                                        onChange={(e) =>
                                            setNewCompany({ ...newCompany, numberofpackage: parseInt(e.target.value, 10) })
                                        }
                                        required
                                    >
                                        <option value={1}>Stempel Uhr</option>
                                        <option value={2}>Planungs</option>
                                    </select>
                                </label>

                                <label>
                                Passwort:
                                    <input
                                        type="password"
                                        value={newCompany.password}
                                        onChange={(e) => setNewCompany({ ...newCompany, password: e.target.value })}
                                        required
                                    />
                                </label>


                                <label>
                                    <input
                                        type="checkbox"
                                        checked={isTextMode}
                                        onChange={() => setIsTextMode(!isTextMode)}
                                    />
                                 Testmodus aktivieren
                                </label>

                                {/* Start Date Field (Always Visible) */}
                                <label>
                                Startdatum:
                                    <input
                                        type="date"
                                        value={newCompany.startdate}
                                        onChange={(e) => setNewCompany({ ...newCompany, startdate: e.target.value })}
                                        required
                                    />
                                </label>

                                {/* End Date Field (Visible only in Text Mode) */}
                                {isTextMode && (
                                    <label>
                                        Enddatum:
                                        <input
                                            type="date"
                                            value={newCompany.enddate}
                                            onChange={(e) => setNewCompany({ ...newCompany, enddate: e.target.value })}
                                        />
                                    </label>
                                )}


                                <label>
                                Kosten:
                                    <input
                                        type="number"
                                        value={newCompany.cost}
                                        onChange={(e) => setNewCompany({ ...newCompany, cost: e.target.value })}
                                        required
                                    />
                                </label>

                                <button type="submit">Unternehmen hinzufügen</button>

                            </form>
                        </div>
                        <button type="button" onClick={closeAddCompanyPopup}>
                        Abbrechen
                        </button>
                    </div>
                </div>
            )}
            {showFilesPopup && (
                <div className="modal-overlay">


                    <div className="modal-content">
                        <div className="modalscroll">
                            <div className='AddEmployeeHeader'>
                            Dateien für Unternehmen {selectedCompanyId}
                            </div>

                            <ul>
                                {files.map((file) => (
                                    <div style={{ borderRadius: "10px", marginBottom: "10px", backgroundColor: "ButtonHighlight" }}>
                                        <li key={file.id}>
                                            {file.descriptions}

                                        </li>
                                        <button onClick={() => handleDownloadFile(file.id, file.filename)}>Herunterladen</button>
                                        <button onClick={() => handleDeleteFile(file.id)}>Löschen</button>
                                    </div>
                                ))}
                            </ul>
                            <hr />

                            <div className='AddEmployeeHeader'>
                            Neue Datei hochladen
                            </div>
                            <input type="file" onChange={(e) => setSelectedFile(e.target.files[0])} />
                            <input
                                type="text"
                                placeholder="Dateibeschreibung"
                                value={fileDescription}
                                onChange={(e) => setFileDescription(e.target.value)}
                            />
                            <button onClick={handleFileUpload}>Hochladen</button>

                        </div>
                        <button onClick={() => setShowFilesPopup(false)}>Schließen</button>
                    </div>
                </div>
            )}
  
        </div>
    );
};

export default Homepage;
